<template>
  <div>
    <InfoDialogBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :pageData="pageData"
      :recItems="recItems"
      :isHistoryType="true"
      :isEdit="true"
      @cancel="cancel"
      @updateRemarks="updateRemarks"
      @dialogReload="dialogReload"
    >
    </InfoDialogBase>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { stockMoveUtil } from '@/util'

import InfoDialogBase from './StorageInfoDialogBase'

import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    InfoDialogBase
    // NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],

    pageType: {
      en: 'sale',
      ja: '注文'
    },

    unitName: ''
  }),
  methods: {
    ...mapActions('StockMove', ['cancelStockMove', 'editStockMove']),

    async ini() {
      const statusName = stockMoveUtil.getStockMoveStatusName(
        this.recItems.status
      )
      this.pageData = [
        {
          title: 'storage.storage_storage-move-info',
          name: 'stockMoveInfo',
          items: [],
          itemKey: ''
        },
        {
          title: `${this.$t('storage.storage_storage-move-detail')}（${
            this.recItems.shipStorage.name
          } → ${this.recItems.loadingStorage.name}）${statusName}`,
          name: 'stockMoveDetail',
          buttonAreaName: 'operationDetailbuttonArea',
          headers: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '8%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '30%',
              class: 'rgba(151, 198, 234, 0.1)'
            },
            {
              text: 'product.product_supplier',
              value: 'product.supplierId',
              sortable: false,
              width: '12%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'storage.storage_storage-move-quantity',
              value: 'quantity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            }
          ],
          items: [],
          footers: [],
          itemKey: this.recItems.stockMoveId
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        }
      ]
    },
    async dialogReload() {
      this.$emit('submit')
      await this.ini()
    },
    register() {
      alert('register')
      this.inputedValue = false
    },
    async updateRemarks(...args) {
      const [id, text] = args
      const isConfirmed = confirm(
        this.$t('common.common_confirm-to-save-remarks')
      )
      if (!isConfirmed) return

      const isSucceed = await this.editStockMove({
        stockMoveId: id,
        note: text
      })
      if (!isSucceed) return
      this.$emit('submit')
    },
    async cancel(id) {
      const isConfirmed = confirm(`
${this.$t('stock-move.stock-move_storage-move-cancel-confirm')}

${this.$t('order.order_irreversible-confirm')}`)

      if (!isConfirmed) return
      const isSucceed = await this.cancelStockMove({ stockMoveId: id })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
        this.$emit('submit')
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    'inputedValue.dialog': async function (val) {
      val ? await this.ini() : null
    }
  }
}
</script>
<style lang="scss" scoped></style>
